// How dates and series positions read on the blog.
export function longDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
}

export function partLabel(part: number | null, series: string | null): string | null {
  return series && part ? `Part ${part} · ${series}` : null;
}
